var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseAccordion',{staticClass:"accordion",attrs:{"data-external":"sb-accordion"}},_vm._l((_vm.items),function(item){return _c('BaseAccordionItem',{key:item.header,attrs:{"header":item.header}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }